export function calculateWorkspace(peopleValue, onsiteValue, clusterValue) {
  const integer = (value, max) => {
    const text = String(value).trim();
    if (!/^\d+$/.test(text)) throw new Error('Invalid planning input');
    const number = Number(text);
    if (!Number.isSafeInteger(number) || number < 1 || number > max) throw new Error('Invalid planning input');
    return number;
  };
  const people = integer(peopleValue, 10000);
  const onsite = integer(onsiteValue, 100);
  const cluster = integer(clusterValue, 8);
  if (![1, 2, 3, 4, 6, 8].includes(cluster)) throw new Error('Unsupported group size');
  const workpoints = Math.ceil(people * onsite / 100);
  const groups = Math.ceil(workpoints / cluster);
  const places = groups * cluster;
  return {people, onsite, cluster, workpoints, groups, places, spare: places - workpoints};
}

export function planningBrief(template, result) {
  return template.replace(/\[\[(people|onsite|cluster|workpoints|groups|places|spare)\]\]/g, (_, key) => String(result[key]));
}

export function planningFromQuery(search) {
  const query = new URLSearchParams(search);
  if (!['planning_people', 'planning_onsite', 'planning_cluster'].every(key => query.has(key))) return null;
  try {
    return calculateWorkspace(query.get('planning_people'), query.get('planning_onsite'), query.get('planning_cluster'));
  } catch (_) {
    return null;
  }
}

if (typeof document !== 'undefined') {
  const planner = document.querySelector('[data-yof-planner]');
  if (planner) {
    const form = planner.querySelector('[data-planner-form]');
    const resultPanel = planner.querySelector('[data-planner-result]');
    const warning = planner.querySelector('[data-planner-error]');
    const shop = planner.querySelector('[data-planner-shop]');
    const quote = planner.querySelector('[data-planner-quote]');
    const quoteBase = quote.href;
    const update = event => {
      event?.preventDefault();
      try {
        if (!form.reportValidity()) throw new Error('Invalid form');
        const data = new FormData(form);
        const result = calculateWorkspace(data.get('people'), data.get('onsite'), data.get('cluster'));
        for (const key of ['workpoints', 'groups', 'places', 'spare']) planner.querySelector(`[data-${key}]`).textContent = result[key];
        planner.querySelector('[data-planning-summary]').value = planningBrief(planner.dataset.brief, result);
        shop.href = result.cluster === 1 ? `${shop.dataset.root}collections/workstations` : `${shop.dataset.root}search?type=product&q=${encodeURIComponent(`"POD of ${result.cluster}"`)}&options%5Bprefix%5D=none`;
        const target = new URL(quoteBase);
        target.searchParams.set('planning_people', result.people);
        target.searchParams.set('planning_onsite', result.onsite);
        target.searchParams.set('planning_cluster', result.cluster);
        quote.href = target.href;
        warning.hidden = true;
        resultPanel.hidden = false;
      } catch (_) {
        resultPanel.hidden = true;
        warning.hidden = false;
      }
    };
    form.addEventListener('submit', update);
    form.addEventListener('input', () => { resultPanel.hidden = true; });
    form.addEventListener('change', () => { resultPanel.hidden = true; });
    update();
  }
  const enquiry = document.getElementById('YofProjectEnquiry');
  const body = enquiry?.querySelector('[name="contact[body]"]');
  const template = enquiry?.querySelector('[data-planning-template]')?.textContent;
  const result = planningFromQuery(window.location.search);
  if (body && result && !body.value.trim() && template) body.value = planningBrief(template, result);
}
